export class SmeltingPreheatingKilnPara {
    constructor({
          id= ``,
          day= ``,  
          time= ``, 
          locName= ``,
          locId= ``,
          shiftName= `default`,
          operatingPower= ``,
          gasMaterialRatio= ``,
          preTemp= ``,
          afterTemp= ``,
          coVolume= ``,
          coPressure= ``,
          coPipePressure1= ``,
          coPipePressure2=``,
          coPower= ``,
          coVibration= ``,
          valveOpening= ``,
          oxVolume= ``,
          oxPressure= ``,
          oxPipePressure1= ``,
          oxPipePressure2= ``,
          oxPower= ``,
          oxVibration= ``,
          circPressure= ``,
          circPressureDiff= ``,
          circOpening= ``,
          fanNumber= ``,
          fanMaxVib= ``,
          fanPower= ``,
          heatCO= ``,
          heatO2= ``,
          heatCO2= ``,
          gasTemp= ``,
          circCO= ``,
          circO2= ``,
          circCO2= ``,
          vaStatus= ``,
          faStatus= ``,
          mixingAveTemp= ``,
          preheatingPressure= ``,
          maxKilnTopTemp= ``,
          materialPipe= ``,
          materialPipeTemp= ``,
      } = {}) {
      this.id = id;
      this.day = day;
      this.time = time;
      this.locName = locName;
      this.locId = locId;
      this.shiftName = shiftName;
      this.operatingPower = operatingPower;
      this.gasMaterialRatio = gasMaterialRatio;
      this.preTemp = preTemp;
      this.afterTemp = afterTemp;
      this.coVolume = coVolume;
      this.coPressure = coPressure;
      this.coPipePressure1 = coPipePressure1;
      this.coPipePressure2 = coPipePressure2;
      this.coPower = coPower;
      this.coVibration = coVibration; 
      this.valveOpening = valveOpening;
      this.oxVolume  = oxVolume;
      this.oxPressure = oxPressure;
      this.oxPipePressure1 = oxPipePressure1;
      this.oxPipePressure2 = oxPipePressure2;
      this.oxPower = oxPower;
      this.oxVibration = oxVibration;
      this.circPressure = circPressure;
      this.circPressureDiff = circPressureDiff;
      this.circOpening = circOpening;
      this.fanNumber = fanNumber;
      this.fanMaxVib = fanMaxVib;
      this.fanPower = fanPower;
      this.heatCO = heatCO;
      this.heatO2 = heatO2;
      this.heatCO2 = heatCO2;
      this.gasTemp = gasTemp;
      this.circCO = circCO;
      this.circO2 = circO2;
      this.circCO2 = circCO2;
      this.vaStatus = vaStatus;
      this.faStatus = faStatus;
      this.mixingAveTemp = mixingAveTemp;
      this.preheatingPressure = preheatingPressure;
      this.maxKilnTopTemp = maxKilnTopTemp;
      this.materialPipe = materialPipe;
      this.materialPipeTemp = materialPipeTemp;
    }
  }
  export function gridFields() {
    return Object.freeze([              
        {
          key: 'day',
          label: 'lbl.basic.date',
          sortable: true,
          form: {
            type: 'datepicker'
          }
        },  
        {
          key: 'time',
          label: 'lbl.basic.datetime',
          sortable: true,
          form: {
            type: 'timepicker'
          }
        },
        {
          key: 'locName',
          label: 'lbl.fm.locationName',
          filterable: true,
          default: 'default',
          form: {
            type: 'dimSearch',
            url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/location/findAll',
            config: {
              validate: "", // 参数检查，可以是正则表达式等
              bindId: 'smeltingLocation', // 绑定的 id, (id 相同的对象会被绑定)
              bindProp: "locName", // 显示的属性的名称
              submitProp: "locName" // 提交的属性
            }
          }
        },
        {
          key: 'locId',
          label: 'lbl.formulaPlan.locationCode',
          notInTable: true,
          form: {
            type: 'dimSearch',
            url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/location/findAll',
            config: {
              validate: "", // 参数检查，可以是正则表达式等
              bindId: 'smeltingLocation', // 绑定的 id, (id 相同的对象会被绑定)
              bindProp: "id", // 显示的属性的名称
              submitProp: "id" // 提交的属性
            }
          }
        },          
        {
          key: 'shiftName',
          label: 'lbl.shiftPlan.shiftName',
          default: 'default',
          sortable: true,
          form: {
            type: 'select',
              options: [
                {value:"default",text:"lbl.basic.select.one"},
                {value:"甲",text:"lbl.shift.A"},
                {value:"乙",text:"lbl.shift.B"},
                {value:"丙",text:"lbl.shift.C"}
              ]
          }
        },
        {
          key: 'operatingPower',
          label: 'lbl.spp.operatingPower',
          sortable: true,
          form: {
            type: 'input'
          }         
        },
        {
          key: 'gasMaterialRatio',
          label: 'lbl.spp.gasMaterialRatio',
          sortable: true,
          form: {
            type: 'input'
          }          
        },
        {
          key: 'preTemp',
          label: 'lbl.spp.preTemp',
          sortable: true,
          form: {
            type: 'input'
          }          
        },
        {
          key: 'afterTemp',
          label: 'lbl.spp.afterTemp',
          sortable: true,
          form: {
            type: 'input'
          }         
        },
        {
          key: 'coVolume',
          label: 'lbl.spp.coVolume',
          sortable: true,
          form: {
            type: 'input'
          }         
        },
        {
          key: 'coPressure',
          label: 'lbl.spp.coPressure',
          sortable: true,
          form: {
            type: 'input'
          }        
        },
        {
          key: 'coPipePressure1',
          label: 'lbl.spp.coPipePressure1',
          sortable: true,
          form: {
            type: 'input'
          }        
        },
        {
          key: 'coPipePressure2',
          label: 'lbl.spp.coPipePressure2',
          sortable: true,
          form: {
            type: 'input'
          }        
        },
        {
          key: 'coPower',
          label: 'lbl.spp.coPower',
          sortable: true,
          form: {
            type: 'input'
          }        
        },
        {
          key: 'coVibration',
          label: 'lbl.spp.coVibration',
          sortable: true,
          form: {
            type: 'input'
          }         
        },
        {
          key: 'valveOpening',
          label: 'lbl.spp.valveOpening',
          sortable: true,
          form: {
            type: 'input'
          }         
        },
        {
          key: 'oxVolume',
          label: 'lbl.spp.oxVolume',
          sortable: true,
          form: {
            type: 'input'
          }         
        },
        {
          key: 'oxPressure',
          label: 'lbl.spp.oxPressure',
          sortable: true,
          form: {
            type: 'input'
          }         
        },
        {
          key: 'oxPipePressure1',
          label: 'lbl.spp.oxPipePressure1',
          sortable: true,
          form: {
            type: 'input'
          }         
        },
        {
          key: 'oxPipePressure2',
          label: 'lbl.spp.oxPipePressure2',
          sortable: true,
          form: {
            type: 'input'
          }         
        },
        {
          key: 'oxPower',
          label: 'lbl.spp.oxPower',
          sortable: true,
          form: {
            type: 'input'
          }         
        },
        {
          key: 'oxVibration',
          label: 'lbl.spp.oxVibration',
          sortable: true,
          form: {
            type: 'input'
          }         
        },
        {
          key: 'circPressure',
          label: 'lbl.spp.circPressure',
          sortable: true,
          form: {
            type: 'input'
          }         
        },
        {
          key: 'circPressureDiff',
          label: 'lbl.spp.circPressureDiff',
          sortable: true,
          form: {
            type: 'input'
          }         
        },
        {
          key: 'circOpening',
          label: 'lbl.spp.circOpening',
          sortable: true,
          form: {
            type: 'input'
          }         
        },
        {
          key: 'fanNumber',
          label: 'lbl.spp.fanNumber',
          sortable: true,
          form: {
            type: 'input'
          }         
        },
        {
          key: 'fanMaxVib',
          label: 'lbl.spp.fanMaxVib',
          sortable: true,
          form: {
            type: 'input'
          }         
        },
        {
          key: 'fanPower',
          label: 'lbl.spp.fanPower',
          sortable: true,
          form: {
            type: 'input'
          }         
        },
        {
          key: 'heatCO',
          label: 'lbl.spp.heatCO',
          sortable: true,
          form: {
            type: 'input'
          }         
        },
        {
          key: 'heatO2',
          label: 'lbl.spp.heatO2',
          sortable: true,
          form: {
            type: 'input'
          }         
        },
        {
          key: 'heatCO2',
          label: 'lbl.spp.heatCO2',
          sortable: true,
          form: {
            type: 'input'
          }         
        },
        {
          key: 'gasTemp',
          label: 'lbl.spp.gasTemp',
          sortable: true,
          form: {
            type: 'input'
          }         
        },
        {
          key: 'circCO',
          label: 'lbl.spp.circCO',
          sortable: true,
          form: {
            type: 'input'
          }         
        },
        {
          key: 'circO2',
          label: 'lbl.spp.circO2',
          sortable: true,
          form: {
            type: 'input'
          }         
        },
        {
          key: 'circCO2',
          label: 'lbl.spp.circCO2',
          sortable: true,
          form: {
            type: 'input'
          }         
        },
        {
          key: 'vaStatus',
          label: 'lbl.spp.vaStatus',
          sortable: true,
          form: {
            type: 'input'
          }         
        },
        {
          key: 'faStatus',
          label: 'lbl.spp.faStatus',
          sortable: true,
          form: {
            type: 'input'
          }         
        },
        {
          key: 'mixingAveTemp',
          label: 'lbl.spp.mixingAveTemp',
          sortable: true,
          form: {
            type: 'input'
          }         
        },
        {
          key: 'preheatingPressure',
          label: 'lbl.spp.preheatingPressure',
          sortable: true,
          form: {
            type: 'input'
          }         
        },
        {
          key: 'maxKilnTopTemp',
          label: 'lbl.spp.maxKilnTopTemp',
          sortable: true,
          form: {
            type: 'input'
          }         
        },
        {
          key: 'materialPipe',
          label: 'lbl.spp.materialPipe',
          sortable: true,
          form: {
            type: 'input'
          }         
        },
        {
          key: 'materialPipeTemp',
          label: 'lbl.spp.materialPipeTemp',
          sortable: true,
          form: {
            type: 'input'
          }         
        }
    ]);
  }
  export const fields = Object.freeze(Object.keys(new SmeltingPreheatingKilnPara()).map(i => 'entity.' + i));
  export const filterFields = [
    'filter.startTimeFilter',
    'filter.endTimeFilter',
    'filter.furnaceCodeFilter',
    'filter.shiftNameFilter',
    'filter.locNameFilter',
  ];
  export const filter = {
    'startTimeFilter': "",
    'endTimeFilter': "",
    'furnaceCodeFilter': "",
    'shiftNameFilter':"default",
    'locNameFilter': "default",
  };